import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  projectCategories: [],
  currentProjectCategory: null,
}

const taskCategorySlice = createSlice({
  name: 'taskCategoryList',
  initialState,
  reducers: {
    setProjectCategories: (state, action) => {
      state.projectCategories = action.payload.projectCategories;
    },
    addProjectCategory: (state, action) => {
      state.projectCategories.push(action.payload);
      state.currentProjectCategory = action.payload;
    },
    deleteProjectCategory: (state, action) => {
      const projectCategoryIndex = state.projectCategories.findIndex(c => c.id === action.payload);
      if (projectCategoryIndex !== -1) {
        state.projectCategories.splice(projectCategoryIndex, 1);
      }
    },
    setCurrentProjectCategory: (state, action) => {
      state.currentProjectCategory = state.projectCategories.find(c => c.id === action.payload) || null;
    },
    clearCurrentProjectCategory: (state) => {
      state.currentProjectCategory = null;
    },
  },
});

export const {
  setProjectCategories,
  addProjectCategory,
  deleteProjectCategory,
  setCurrentProjectCategory,
  clearCurrentProjectCategory,
} = taskCategorySlice.actions;

export default taskCategorySlice.reducer;
